// extracted by mini-css-extract-plugin
module.exports = {"powerstream-cooperation-B":"B_powerstream-cooperation-B__2mhQ1"};